module.exports = __webpack_public_path__ + "static/img/Tangga DSK tampak samping.8b279cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Tangga DSK tampak samping.jpg
// module id = 108
// module chunks = 1